import un from 'underscore'

const productUtils = {
  createProductForNewPrice: function(product, newPrice) {
    var newProduct = un.create(product)
    newProduct.storeData.price = newPrice
    return newProduct
  }
}

export default productUtils



// WEBPACK FOOTER //
// ./src/service/productUtils.js